module.exports = __webpack_public_path__ + "img/bottomList2.51d40019.svg";